import type {Store} from 'vuex';
import type {RootState} from '@/types/RootState';
import {d} from '@/utils/consoleHelper';

const SUPER_ADMIN_ROLE = 'super-admin';

export default async function superAdmin({store}: { store: Store<RootState> }): Promise<boolean> {
    d.log('%c -- MIDDLEWARE -- SUPER ADMIN ✅', 'color: white;background: purple; padding: 2px; font-weight: bold;');

    const roles: string[] = store.getters['auth/roles'] ?? [];

    if (!roles.includes(SUPER_ADMIN_ROLE)) {
        d.warn('%c 🚫 User does not have super-admin role - Redirecting to dashboard', 'color: orange; font-weight: bold;');
        return false;
    }

    return true;
}
